module.exports = __webpack_public_path__ + "static/media/Food Logistics.150e8154.png";